import { useMutation } from "@tanstack/react-query";
import { buildReportAsync } from "../api";
import { DEFAULT_PERSONA, getPersonaByValue } from "../utils/personas";
import { useUpdateReport } from "./useReportHistory";

export function useRebuildReportAsync() {
  const updateReport = useUpdateReport();
  return useMutation({
    mutationFn: async ({ id, request, persona = DEFAULT_PERSONA.value }) => {
      const personaVersion = getPersonaByValue(persona).version;
      const r = await buildReportAsync({ user_request: request, persona: personaVersion });
      const taskId = r.task_id;
      const reportData = {
        id,
        taskId,
        request,
        persona,
        plan: undefined,
        simplePlan: undefined,
        status: "requested",
        progress: 0,
        progressDetails: null,
        taskStatus: "init",
        completedAt: null,
        report: null,
      };
      updateReport.mutate({ id, updates: reportData });
      return reportData;
    },
  });
}
